import { css } from '@emotion/react';
import vars from '../../../styles/custom-properties.js';

var getAlignItem = function getAlignItem(alignment) {
  switch (alignment) {
    case 'flexStart':
      return 'flex-start';
    case 'flexEnd':
      return 'flex-end';
    default:
      return alignment;
  }
};
var getMargin = function getMargin(scale) {
  switch (scale) {
    case 'xs':
      return vars.spacingXs;
    case 's':
      return vars.spacingS;
    case 'm':
      return vars.spacingM;
    case 'l':
      return vars.spacingL;
    case 'xl':
      return vars.spacingXl;
    default:
      return 0;
  }
};
var getStackStyles = function getStackStyles(props) {
  return css("display:flex;flex-direction:column;align-items:", getAlignItem(props.alignItems), ";>*+*{margin:", getMargin(props.scale), " 0 0 ", props.noImportant ? '' : '!important', ";}" + ("production" === "production" ? "" : ";label:getStackStyles;"), "production" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE0QnNDIiwiZmlsZSI6InN0eWxlcy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IGN1c3RvbVByb3BlcnRpZXMgYXMgdmFycyB9IGZyb20gXCIuLi8uLi8uLi9zdHlsZXNcIjtcbmNvbnN0IGdldEFsaWduSXRlbSA9IChhbGlnbm1lbnQpID0+IHtcbiAgICBzd2l0Y2ggKGFsaWdubWVudCkge1xuICAgICAgICBjYXNlICdmbGV4U3RhcnQnOlxuICAgICAgICAgICAgcmV0dXJuICdmbGV4LXN0YXJ0JztcbiAgICAgICAgY2FzZSAnZmxleEVuZCc6XG4gICAgICAgICAgICByZXR1cm4gJ2ZsZXgtZW5kJztcbiAgICAgICAgZGVmYXVsdDpcbiAgICAgICAgICAgIHJldHVybiBhbGlnbm1lbnQ7XG4gICAgfVxufTtcbmNvbnN0IGdldE1hcmdpbiA9IChzY2FsZSkgPT4ge1xuICAgIHN3aXRjaCAoc2NhbGUpIHtcbiAgICAgICAgY2FzZSAneHMnOlxuICAgICAgICAgICAgcmV0dXJuIHZhcnMuc3BhY2luZ1hzO1xuICAgICAgICBjYXNlICdzJzpcbiAgICAgICAgICAgIHJldHVybiB2YXJzLnNwYWNpbmdTO1xuICAgICAgICBjYXNlICdtJzpcbiAgICAgICAgICAgIHJldHVybiB2YXJzLnNwYWNpbmdNO1xuICAgICAgICBjYXNlICdsJzpcbiAgICAgICAgICAgIHJldHVybiB2YXJzLnNwYWNpbmdMO1xuICAgICAgICBjYXNlICd4bCc6XG4gICAgICAgICAgICByZXR1cm4gdmFycy5zcGFjaW5nWGw7XG4gICAgICAgIGRlZmF1bHQ6XG4gICAgICAgICAgICByZXR1cm4gMDtcbiAgICB9XG59O1xuY29uc3QgZ2V0U3RhY2tTdHlsZXMgPSAocHJvcHMpID0+IGNzcyBgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGFsaWduLWl0ZW1zOiAke2dldEFsaWduSXRlbShwcm9wcy5hbGlnbkl0ZW1zKX07XG5cbiAgPiAqICsgKiB7XG4gICAgbWFyZ2luOiAke2dldE1hcmdpbihwcm9wcy5zY2FsZSl9IDAgMCAke3Byb3BzLm5vSW1wb3J0YW50ID8gJycgOiAnIWltcG9ydGFudCd9O1xuICB9XG5gO1xuZXhwb3J0IHsgZ2V0U3RhY2tTdHlsZXMgfTtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPXN0eWxlcy5qcy5tYXAiXX0= */");
};

export { getStackStyles };
//# sourceMappingURL=styles.js.map
